import { CONFIG } from '@gallaghercp/core-frontend';
export const APP_CONFIG: CONFIG = {
    appName: 'SCI Benefits',
    frontend: 'https://benefits.sci-corp.com',
    apiHash: 'https://benefits.sci-corp.com/api/1.0',
    api: '/api/2.0',
    modernised: true,
    authHeaders: {
        xServiceProvider: 'sci-prod-frontend',
        'tenant-id': '7ef021b9-fb32-414d-9a83-39422e769040',
        'consumer-id': '874acd42-5ca5-4953-8c73-e484d2e658a9',
    },
    commitSHA: '0970b1f',
    provider: 'sci-prod-frontend',
} as CONFIG;

